export const hash = (str) => {
  if (!str?.length) return "";
  let h = 0;
  for (let i = 0; i < str.length; i++) {
    h = (h * 31 + str.charCodeAt(i)) % 0xffffffff;
  }
  return h.toString(16);
};
